import { biLoggerFactory } from 'wix-private';
 
const msid = '5a3b59b1-568e-4b3f-9077-a8d4824b71b6';
 
const biGroupsLoggers = {
    80: biLoggerFactory('potential-experts', 80, { msid }),//504
    81: biLoggerFactory('expert-dashboard', 80, { msid }),//238
    82: biLoggerFactory('expert-dashboard', 80, { msid }),//243
    19: biLoggerFactory('lp', 19, { msid })//703
}
 
export async function fireBIEvent(src, evid, fields) {
 
    const biLogger = biGroupsLoggers[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}
